var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3105 3.8999H11.3105L9.31047 1.8999H6.48047L10.4805 5.8999H19.3105V15.0699L21.0705 16.8299C21.2205 16.5499 21.3105 16.2399 21.3105 15.8999V5.8999C21.3105 4.7999 20.4105 3.8999 19.3105 3.8999Z",
    fill: "#FF0801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41 0L0 1.41L1.56 2.97C1.41 3.25 1.32 3.56 1.32 3.9L1.31 15.9C1.31 17 2.21 17.9 3.31 17.9H16.48L19.79 21.21L21.2 19.8L1.41 0ZM3.31 15.9V4.73L14.48 15.9H3.31Z",
    fill: "#FF0801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFile);
export default __webpack_public_path__ + "static/media/errorFile.c73c47f1983a938f1547d5f7e476f850.svg";
export { ForwardRef as ReactComponent };